<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path d="m13 4.3-1.5 1.4L21.8 16 11.5 26.3l1.5 1.4 11-11 .7-.7-.7-.7Z" />
  </svg>
</template>
